const PropTypes = require('prop-types');
// @vendors
const React = require('react');

// @utils
const { FormattedText } = require('core/i18n').i18n;

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');

// @constants
const {
    BROKER_RISK_BUTTON_LOW_RISK,
    BROKER_RISK_BUTTON_MEDIUM_RISK,
    BROKER_RISK_BUTTON_HIGH_RISK
} = require('constants/index');

class RiskButtonsGroup extends React.Component {
    constructor(props) {
        super(props);

        this.handleRisk = this.handleRisk.bind(this);
        this.handleLowRisk = this.handleLowRisk.bind(this);
        this.handleMediumRisk = this.handleMediumRisk.bind(this);
        this.handleHighRisk = this.handleHighRisk.bind(this);
    }

    handleHighRisk() {
        this.handleRisk('high');
    }

    handleLowRisk() {
        this.handleRisk('low');
    }

    handleMediumRisk() {
        this.handleRisk('medium');
    }

    handleRisk(riskType) {
        const [lowRiskIsActive, mediumRiskIsActive, highRiskIsActive] = this.props.risks;
        const actives = [lowRiskIsActive, mediumRiskIsActive, highRiskIsActive].filter(active => active);

        let isRiskActive;
        // Verify if the risk recently clicked is currently active
        switch (riskType) {
            case BROKER_RISK_BUTTON_LOW_RISK:
                isRiskActive = lowRiskIsActive;
                break;
            case BROKER_RISK_BUTTON_MEDIUM_RISK:
                isRiskActive = mediumRiskIsActive;
                break;
            case BROKER_RISK_BUTTON_HIGH_RISK:
                isRiskActive = highRiskIsActive;
                break;
        }

        // If there are at least two buttons actives
        // or the current risk button is not selected you can toggle the button risk
        if (actives.length > 1 || !isRiskActive) {
            this.props.onHandleRiskChange(riskType);
        }
    }

    render() {
        const [lowRiskIsActive, mediumRiskIsActive, highRiskIsActive] = this.props.risks;

        const lowRiskModifier = lowRiskIsActive ? 'secondary' : 'ghost';
        const mediumRiskModifier = mediumRiskIsActive ? 'secondary' : 'ghost';
        const highRiskModifier = highRiskIsActive ? 'secondary' : 'ghost';

        return (
            <div className="broker-advanced-search-explore__risk-buttons">
                <div className="broker-advanced-search-explore__risk-button-container">
                    <OKButton
                        id="btnAdvancedSearchLowRisk"
                        block={true}
                        size="small"
                        modifier={lowRiskModifier}
                        onClick={this.handleLowRisk}
                    >
                        <FormattedText value="broker-advancedSearchLowRisk" />
                    </OKButton>
                </div>
                <div className="broker-advanced-search-explore__risk-button-container">
                    <OKButton
                        id="btnAdvancedSearchMediumRisk"
                        block={true}
                        size="small"
                        modifier={mediumRiskModifier}
                        onClick={this.handleMediumRisk}
                    >
                        <FormattedText value="broker-advancedSearchMediumRisk" />
                    </OKButton>
                </div>
                <div className="broker-advanced-search-explore__risk-button-container">
                    <OKButton
                        id="btnAdvancedSearchHighRisk"
                        block={true}
                        size="small"
                        modifier={highRiskModifier}
                        onClick={this.handleHighRisk}
                    >
                        <FormattedText value="broker-advancedSearchHighRisk" />
                    </OKButton>
                </div>
            </div>
        );
    }
}

RiskButtonsGroup.propTypes = {
    onHandleRiskChange: PropTypes.func,
    risks: PropTypes.array
};

module.exports = RiskButtonsGroup;